(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1896],{

/***/ 13917:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/edit/styles",
      function () {
        return __webpack_require__(80029);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ SiteBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86542);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76195);
/* harmony import */ var datocms_structured_text_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62338);



function SiteBanner(param) {
    var content = param.content, enabled = param.enabled;
    return enabled && !(0,datocms_structured_text_utils__WEBPACK_IMPORTED_MODULE_1__/* .isEmptyDocument */ .RL)(content) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-stealth-bomber text-white px-7 py-4 flex justify-center text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_datocms__WEBPACK_IMPORTED_MODULE_2__/* .StructuredText */ .rZ, {
            data: content,
            customMarkRules: [
                (0,react_datocms__WEBPACK_IMPORTED_MODULE_3__/* .renderMarkRule */ .zf)("strong", function(param) {
                    var children = param.children, key = param.key;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                        className: "font-medium",
                        children: children
                    }, key);
                }), 
            ]
        })
    }) : null;
}



/***/ }),

/***/ 80029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63430);
/* harmony import */ var react_datocms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12569);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80338);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26499);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88038);
/* harmony import */ var _modules_site_banner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6985);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67199);
/* harmony import */ var _narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_5__);








var EditStylesPage = function(param) {
    var preview = param.preview, subscription = param.subscription;
    var ref = (0,react_datocms__WEBPACK_IMPORTED_MODULE_6__/* .useQuerySubscription */ .L)(subscription), tmp = ref.data, ref1 = tmp === void 0 ? {} : tmp, data = ref1.page, banner = ref1.banner;
    if (!data) return null;
    var seo = data.seo, title = data.title, description = data.description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Layout */ .Ar, {
        product: "edit",
        preview: preview,
        siteBanner: banner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_site_banner__WEBPACK_IMPORTED_MODULE_4__/* .SiteBanner */ .b, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, banner)) : null,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SEO */ .HJ, {
                title: "Narrative | Fast image editing | Photographers",
                children: (0,react_datocms__WEBPACK_IMPORTED_MODULE_8__/* .renderMetaTags */ .y)(seo)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules__WEBPACK_IMPORTED_MODULE_3__/* .EditStylesHeroSection */ .EP, {
                title: title,
                description: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules__WEBPACK_IMPORTED_MODULE_3__/* .EditStylesBodySection */ .wX, {
                artistStyles: data.artistStyles
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_narrative_software_narrative_web_ui__WEBPACK_IMPORTED_MODULE_5__.PromoBanner, {
                title: "Try our game changing software today",
                description: "Get started with Narrative for free on macOS. No credit card required.",
                form: _config__WEBPACK_IMPORTED_MODULE_2__/* .IS_GOOGLE_AUTH_ENABLED */ .Hw ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .StartFreeButtons */ .zH, {
                    product: "edit",
                    className: "max-w-130"
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .SignUpForm */ .WS, {
                    product: "edit",
                    className: "max-w-160",
                    textClassName: "text-white"
                }),
                backgroundColour: "ekans",
                backgroundImagePath: "/images/textures/ekans-bg@2x.png",
                large: true
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (EditStylesPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(13917); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);